module.exports = __webpack_public_path__ + "images/mobile/arrow-line-s-cc0554724aeb31bcca70a79ef0c97b62.png";